"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeRangePicker = void 0;
var react_1 = __importStar(require("react"));
var InlineAlert_1 = require("../InlineAlert");
var DatePicker_1 = __importDefault(require("../DatePicker"));
var TimeRangePicker_1 = require("../TimeRangePicker");
var BlockLabel_1 = require("../../v2/components/BlockLabel");
var getBlockLabelProps_1 = require("../../utils/getBlockLabelProps");
var DateTimeRangePicker = function (props) {
    var onChange = props.onChange, value = props.value, id = props.id, readOnly = props.readOnly, futureDateOnly = props.futureDateOnly, previousDateOnly = props.previousDateOnly, passChangeHandlerOps = props.passChangeHandlerOps, invert = props.invert, isPassedText = props.isPassedText, disabled = props.disabled;
    var _a = (0, react_1.useState)(value), _value = _a[0], _setValue = _a[1];
    var checkIfDatePassed = function (date) {
        if (!date)
            return false;
        var givenDate = new Date(date);
        var today = new Date();
        return givenDate > today ? false : true;
    };
    var _b = (0, react_1.useState)(checkIfDatePassed(value === null || value === void 0 ? void 0 : value.date)), isPassed = _b[0], setIsPassed = _b[1];
    var handleOnChange = function (k, v) {
        var _a;
        var newVal = __assign(__assign({}, _value), (_a = {}, _a[k] = v, _a));
        if (newVal.date && newVal.timeRange && newVal.timeRange[0]) {
            // date returned by datepicker is ISO (meaning GMT time) 
            // we need to get IST. Date class will convert it to IST.
            var date = new Date(newVal.date);
            var timeSplit = newVal.timeRange[0].split(':');
            //set the time within the date string using the timeValue numbers
            date.setHours(timeSplit[0]);
            date.setMinutes(timeSplit[1]);
            date.setSeconds(timeSplit[2] || "00");
            newVal = (__assign(__assign({}, newVal), { date: date.toISOString() }));
        }
        _setValue(newVal);
        setIsPassed(checkIfDatePassed(newVal.date));
        if (newVal.date && newVal.timeRange && newVal.timeRange[0] && newVal.timeRange[1]) {
            onChange && onChange(id, newVal, passChangeHandlerOps && props);
        }
    };
    (0, react_1.useEffect)(function () {
        if (value && (value.date !== _value.date ||
            (value.timeRange && _value.timeRange && value.timeRange.some(function (v, i) { return v !== _value.timeRange[i]; })))) { // if there is a change basically
            _setValue(value);
        }
    }, [value]);
    return (react_1.default.createElement("div", { id: id },
        react_1.default.createElement(BlockLabel_1.BlockLabel, __assign({}, (0, getBlockLabelProps_1.getBlockLabelProps)(props))),
        react_1.default.createElement("div", { style: { display: 'flex', flexWrap: 'wrap', columnGap: '4rem', rowGap: '2rem' } },
            react_1.default.createElement(DatePicker_1.default, { value: _value === null || _value === void 0 ? void 0 : _value.date, onChange: function (k, v) { return handleOnChange('date', v); }, readOnly: readOnly, futureDateOnly: futureDateOnly, previousDateOnly: previousDateOnly, invert: invert, disabled: disabled }),
            react_1.default.createElement(TimeRangePicker_1.TimeRangePicker, { value: _value === null || _value === void 0 ? void 0 : _value.timeRange, onChange: function (k, v) { return handleOnChange('timeRange', v); }, readOnly: readOnly, invert: invert, disabled: disabled })),
        isPassed && react_1.default.createElement(InlineAlert_1.InlineAlert, { type: 'danger', text: isPassedText || 'This Date Is Passed' })));
};
exports.DateTimeRangePicker = DateTimeRangePicker;
